<template>
  <section>
    <template v-if="list == null || list.length === 0">
      <div class="p-5 bg-light text-center">
        <span>
          {{$t("errors.not_found")}}
        </span>
      </div>
    </template>

    <template v-if="list.length > 0 && mode === 'grid'">

      <div v-if="selectedCourse != null && !reselectingCourse"
           role="button"
           class="overflow-hidden p-1"
           v-on:click="reselectCourse">
        <img v-for="(course, index) in list"
             :src="`https://version280.cloud-manabibako.com/elearning/Image/icon/${getValue(course, levelKey) == 0 ? 'box' : getValue(course, levelKey) == 1 ? 'book' : 'return_book'}${getValue(course, iconColorKey)}.gif`"
             :class="{'opacity-50': getValue(selectedCourse, idKey) != getValue(course, idKey)}"
             draggable="false"
             class="w-auto hr-2 my-1" />
      </div>

      <div v-if="selectedCourse == null || reselectingCourse"
           class="d-flex flex-wrap row-cols-3 row-cols-md-5 row-cols-lg-7 row-cols-xxl-10">
        <section v-for="(course, index) in list"
                 class="d-flex flex-column align-items-center p-2"
                 :class="{'opacity-50': selectedCourse != null && getValue(selectedCourse, idKey) != getValue(course, idKey)}"
                 v-on:click="selectContainer(getValue(course, idKey), true)">
          <img :src="`https://version280.cloud-manabibako.com/elearning/Image/icon/${getValue(course, levelKey) == 0 ? 'box' : getValue(course, levelKey) == 1 ? 'book' : 'return_book'}${getValue(course, iconColorKey)}.gif`"
               draggable="false"
               class="w-auto hr-6 my-2" />
          <span class="w-100 small overflow-hidden d-webkit-box webkit-box-orient-vertical webkit-line-clamp-3 px-2 mb-2 border small">
            {{getValue(course, nameKey)}}
          </span>
        </section>
      </div>

      <div v-if="selectedCourse != null"
           ref="selectedCourseContainer"
           class="border-top border-bottom"
           v-on:click="selectCourse">
        <div class="d-flex align-items-center p-2">
          <img :src="`https://version280.cloud-manabibako.com/elearning/Image/icon/${getValue(selectedCourse, levelKey) == 1 ? 'open_book' : getValue(selectedCourse, levelKey) == 2 ? 'return_book' : 'open_box'}${getValue(selectedCourse, iconColorKey)}.gif`"
               draggable="false"
               class="m-2" />
          <div class="m-2 flex-grow-1">
            <h6>
              {{getValue(selectedCourse, nameKey)}}
            </h6>
            <span class="mt-2">
              {{getValue(selectedCourse, overviewKey)}}
            </span>
          </div>
        </div>
        <progress-bar class="m-2 mt-0 small"
                      :value="getValue(selectedCourse, progressKey)"
                      :size="0.75" />
        <div class="text-end" v-if="!hasChild(selectedCourse)">
          <button class="btn btn-link">
            詳細へ
          </button>
        </div>
      </div>

      <template v-if="selectedCourse != null && hasChild(selectedCourse)">
        <course-list-container :mode="mode"
                               :courses="getValue(selectedCourse, childrenKey)"
                               :columns="columns"
                               :idKey="idKey"
                               :nameKey="nameKey"
                               :overviewKey="overviewKey"
                               :progressKey="progressKey"
                               :iconColorKey="iconColorKey"
                               :startAtKey="startAtKey"
                               :endAtKey="endAtKey"
                               :childrenKey="childrenKey"
                               v-on:select="propagateSelect" />
      </template>

    </template>

    <template v-if="list.length > 0 && mode === 'vertical'">
      <div v-for="(course, index) in list">

        <div v-if="selectedCourse == null || getValue(course, idKey) !== getValue(selectedCourse, idKey)"
             class="d-flex flex-wrap align-items-center p-2 border-top"
             v-on:click="selectContainer(getValue(course, idKey), true)"
             :class="{'border-start': getValue(course, levelKey) > 0, 'opacity-50': selectedCourse != null && getValue(selectedCourse, idKey) != getValue(course, idKey)}"
             :style="'margin-left:' + getValue(course, levelKey) + 'rem !important;'">
          <img :src="`https://version280.cloud-manabibako.com/elearning/Image/icon/${getValue(course, levelKey) == 0 ? 'box' : getValue(course, levelKey) == 1 ? 'book' : 'return_book'}${getValue(course, iconColorKey)}.gif`"
               draggable="false"
               class="w-auto hr-5"/>
          <span>
            {{getValue(course, nameKey)}}
          </span>
          <progress-bar class="m-1 small w-100"
                        :value="getValue(course, progressKey)"
                        :size="0.50" />
        </div>

        <div v-if="selectedCourse != null && getValue(course, idKey) === getValue(selectedCourse, idKey)"
             ref="selectedCourseContainer"
             :style="'margin-left:' + getValue(course, levelKey) + 'rem !important;'"
             :class="{'border-start': getValue(course, levelKey) > 0}"
             v-on:click="selectCourse">
          <div class="d-flex border-top p-2">
            <img :src="`https://version280.cloud-manabibako.com/elearning/Image/icon/${getValue(selectedCourse, levelKey) == 1 ? 'open_book' : getValue(selectedCourse, levelKey) == 2 ? 'return_book' : 'open_box'}${getValue(selectedCourse, iconColorKey)}.gif`"
                 draggable="false"
                 class="hr-5" />
            <div class="m-2 flex-grow-1">
              <h6>
                {{getValue(selectedCourse, nameKey)}}
              </h6>
              <span class="mt-2">
                {{getValue(selectedCourse, overviewKey)}}
              </span>
            </div>
          </div>
          <progress-bar class="m-1 small"
                        :value="getValue(course, progressKey)"
                        :size="0.50" />

          <div class="text-end" v-if="!hasChild(selectedCourse)">
            <button class="btn btn-link">
              詳細へ
            </button>
          </div>
        </div>

        <template v-if="selectedCourse != null && getValue(course, idKey) === getValue(selectedCourse, idKey) && hasChild(selectedCourse)">
          <course-list-container :mode="mode"
                                 :courses="getValue(selectedCourse, childrenKey)"
                                 :columns="columns"
                                 :idKey="idKey"
                                 :nameKey="nameKey"
                                 :overviewKey="overviewKey"
                                 :progressKey="progressKey"
                                 :iconColorKey="iconColorKey"
                                 :startAtKey="startAtKey"
                                 :endAtKey="endAtKey"
                                 :childrenKey="childrenKey"
                                 v-on:select="propagateSelect" />
        </template>

      </div>
    </template>

    <template v-if="list.length > 0 && mode === 'horizontal'">
      <div class="d-flex">
        <button type="button" class="btn p-0"
                v-on:click="pageBackward">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        </button>

        <div class="__horizontal_container d-flex flex-grow-1 overflow-hidden user-select-none row-cols-3 row-cols-md-5 row-cols-lg-7 row-cols-xxl-10"
             ref="horizontalContainer">
          <section v-for="(course, index) in list"
                   class="d-flex flex-column align-items-center p-2"
                   :class="{'opacity-50': selectedCourse != null && getValue(selectedCourse, idKey) != getValue(course, idKey)}"
                   v-on:click="selectContainer(getValue(course, idKey), true)"
                   ref="horizontalCourseItem">
            <img :src="`https://version280.cloud-manabibako.com/elearning/Image/icon/${getValue(course, levelKey) == 0 ? 'box' : getValue(course, levelKey) == 1 ? 'book' : 'return_book'}${getValue(course, iconColorKey)}.gif`"
                 draggable="false"
                 class="w-auto hr-6 my-2" />
            <span class="w-100 overflow-hidden d-webkit-box webkit-box-orient-vertical webkit-line-clamp-3 px-2 mb-2 border small">
              {{getValue(course, nameKey)}}
            </span>
            <progress-bar class="mt-auto small w-100"
                          :value="getValue(course, progressKey)"
                          :size="0.75" />
          </section>
        </div>

        <button type="button" class="btn p-0"
                v-on:click="pageForward">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
        </button>
      </div>

      <div v-if="selectedCourse != null"
           ref="selectedCourseContainer"
           class="border-top border-bottom p-2"
           v-on:click="selectCourse">
        <div class="d-flex flex-row">
          <div>
            <img :src="`https://version280.cloud-manabibako.com/elearning/Image/icon/${getValue(selectedCourse, levelKey) == 1 ? 'open_book' : getValue(selectedCourse, levelKey) == 2 ? 'return_book' : 'open_box'}${getValue(selectedCourse, iconColorKey)}.gif`"
                 draggable="false"
                 class="m-2" />
            <progress-bar class="m-2 small"
                          :value="getValue(selectedCourse, progressKey)"
                          :size="0.75" />
          </div>
          <div class="m-2 flex-grow-1">
            <h6>
              {{getValue(selectedCourse, nameKey)}}
            </h6>
            <p class="mt-2">
              {{getValue(selectedCourse, overviewKey)}}
            </p>
          </div>
        </div>
        <div class="text-end" v-if="!hasChild(selectedCourse)">
          <button class="btn btn-link">
            詳細へ
          </button>
        </div>
      </div>

      <template v-if="selectedCourse != null && hasChild(selectedCourse)">
        <course-list-container :mode="mode"
                               :courses="getValue(selectedCourse, childrenKey)"
                               :columns="columns"
                               :idKey="idKey"
                               :nameKey="nameKey"
                               :overviewKey="overviewKey"
                               :progressKey="progressKey"
                               :iconColorKey="iconColorKey"
                               :startAtKey="startAtKey"
                               :endAtKey="endAtKey"
                               :childrenKey="childrenKey"
                               v-on:select="propagateSelect"/>
      </template>
    </template>
  </section>
</template>

<style scoped>
  .__horizontal_container {
    touch-action: none;

    & .__style_a
      {
        background-color: red;
      }
  }

  .carousel-control-prev-icon,
  .carousel-control-next-icon {
    filter: invert(1) grayscale(100);
  }
</style>

<script>
  import { defineComponent } from "vue";
  import Spinner from "utils/spinner";
  import { xhrRequest } from "utils/xhr";
  import { scrollLeft, stopAnimation } from "utils/animation";

  import ProgressBarControl from "components/control/progress_bar_control";

  export default defineComponent({
    name: "course-list-container",
    props: {
      mode: {
        type: String,
        default: "horizontal",
        validator: (val) => {
          return [null, "vertical", "horizontal", "grid"].includes(val);
        }
      },
      courses: {
        type: Array,
        required: true,
      },
      columns: {
        type: Number,
        default: 5,
        validator: (val) => {
          return 0 < val && val <= 10;
        },
      },
      idKey: {
        type: String,
        default: "id",
      },
      nameKey: {
        type: String,
        default: "name",
      },
      overviewKey: {
        type: String,
        default: "overview",
      },
      progressKey: {
        type: String,
        default: "progress",
      },
      levelKey: {
        type: String,
        default: "level",
      },
      iconColorKey: {
        type: String,
        default: "option.iconColorId",
      },
      startAtKey: {
        type: String,
        default: "option.startAt",
      },
      endAtKey: {
        type: String,
        default: "option.endAt",
      },
      childrenKey: {
        type: String,
        default: "courses",
      },
    },
    computed: {
    },
    data: () => {
      return {
        list: [],
        selectedCourse: null,
        reselectingCourse: false,
        horizontalCourseItems: null,
        horizontalContainer: null,
        horizontalStratPosition: 0,
        horizontalScrolledValue: 0,
        previousScrollPosition1: 0,
        previousScrollPosition2: 0,
        horizontalScrollTimer: null,
        horizontalScrolling: false,
      }
    },
    methods: {
      initialize() {
        this.selectedCourse = null;
        this.list = this.courses;
        this.updateDOM();
      },
      updateDOM() {
        this.$nextTick(function () {
          this.horizontalContainer = this.$refs.horizontalContainer;
          this.horizontalCourseItems = this.$refs.horizontalCourseItem;
          if (this.horizontalContainer != null) {
            this.horizontalContainer.removeEventListener("pointerdown", this.scrollStart);
            this.horizontalContainer.addEventListener("pointerdown", this.scrollStart);
          }
          if (this.list.length === 1) this.selectedCourse = this.list[0];
        });
      },
      getValue(target, key) {
        let objectKeyList = Object.keys(target);
        if (objectKeyList.includes(key)) return target[key];
        let keys = key.split(".");
        if (keys.length <= 1) return null;
        for (let i = 1; i < keys.length; i++) {
          let joinedKey = keys.slice(0, keys.length - i).join(".");
          if (objectKeyList.includes(joinedKey)) return this.getValue(target[joinedKey], keys.slice(keys.length - i).join("."));
        }
        return null;
      },
      hasChild(target) {
        let v = this.getValue(target, this.childrenKey);
        return v != null && Array.isArray(v) && v.length > 0;
      },
      selectContainer(id, moveToTop = false) {
        if (this.horizontalScrolling) return;
        this.selectedCourse = this.list.find(i => i[this.idKey] === id);
        this.reselectingCourse = false;
        if (!moveToTop) return;
        this.$nextTick(() => {
          let target = this.$refs.selectedCourseContainer;
          if (Array.isArray(target)) {
            window.scroll({ top: target[0].getBoundingClientRect().top + window.scrollY, behavior: "smooth", });
          } else {
            window.scroll({ top: target.getBoundingClientRect().top + window.scrollY, behavior: "smooth", });
          }
        });
      },
      reselectCourse() {
        this.reselectingCourse = true;
      },
      selectCourse() {
        if (this.mode === "vertical") {
          if (this.hasChild(this.selectedCourse)) {
            this.selectedCourse = null;
            return;
          }
          this.$emit("select", this.getValue(this.selectedCourse, this.idKey));
          return;
        }
        if (this.hasChild(this.selectedCourse)) return;
        this.$emit("select", this.getValue(this.selectedCourse, this.idKey));
      },
      propagateSelect(id) {
        this.$emit("select", id);
      },
      getHorizontalActiveItems() {
        if (this.horizontalContainer == null || this.horizontalCourseItems == null || this.horizontalCourseItems.length == 0) return null;
        let hStart = this.horizontalContainer.getBoundingClientRect().left;
        let hEnd = this.horizontalContainer.getBoundingClientRect().right;
        return this.horizontalCourseItems.filter(i => {
          return hStart <= i.getBoundingClientRect().left && i.getBoundingClientRect().right <= hEnd;
        });
      },
      getHorizontalFirstActiveItemIndex() {
        if (this.horizontalContainer == null || this.horizontalCourseItems == null || this.horizontalCourseItems.length == 0) return -1;
        let hStart = this.horizontalContainer.getBoundingClientRect().left;
        let hEnd = this.horizontalContainer.getBoundingClientRect().right;
        return this.horizontalCourseItems.findIndex(i => {
          return hStart <= i.getBoundingClientRect().left && i.getBoundingClientRect().right <= hEnd;
        });
      },
      getHorizontalLastActiveItemIndex() {
        if (this.horizontalContainer == null || this.horizontalCourseItems == null || this.horizontalCourseItems.length == 0) return -1;
        let hStart = this.horizontalContainer.getBoundingClientRect().left;
        let hEnd = this.horizontalContainer.getBoundingClientRect().right;
        return this.horizontalCourseItems.findLastIndex(i => {
          return hStart <= i.getBoundingClientRect().left && i.getBoundingClientRect().right <= hEnd;
        });
      },
      pageForward() {
        stopAnimation();
        let target = this.horizontalCourseItems[this.getHorizontalLastActiveItemIndex() + 1];
        if (target == null) {
          this.horizontalContainer.scroll({ left: this.horizontalContainer.scrollWidth, behavior: "smooth", });
          return;
        }
        let val = this.horizontalContainer.scrollLeft + target.getBoundingClientRect().left - this.horizontalContainer.getBoundingClientRect().left;
        this.horizontalContainer.scroll({ left: val, behavior: "smooth", });
      },
      pageBackward() {
        let target = this.horizontalCourseItems[this.getHorizontalFirstActiveItemIndex() - 1];
        if (target == null) {
          this.horizontalContainer.scroll({ left: 0, behavior: "smooth", });
          return;
        }
        let hccr = this.horizontalContainer.getBoundingClientRect();
        let val = this.horizontalContainer.scrollLeft + hccr.left - hccr.width - target.getBoundingClientRect().right;
        this.horizontalContainer.scroll({ left: val, behavior: "smooth", });
      },
      scrollStart(e) {
        stopAnimation();
        this.horizontalStratPosition = e.screenX;
        this.previousScrollPosition1 = e.screenX;
        this.previousScrollPosition2 = e.screenX;
        this.horizontalScrolledValue = this.horizontalContainer.scrollLeft;
        window.addEventListener("pointermove", this.scrollMove);
        window.addEventListener("pointerup", this.scrollEnd, { once: true });
      },
      scrollMove(e) {
        let px = e.screenX;
        let dx = this.horizontalStratPosition - px;
        if (dx <= -10 || 10 <= dx) this.horizontalScrolling = true;
        if (this.horizontalScrollTimer != null) {
          clearTimeout(this.horizontalScrollTimer);
          this.horizontalScrollTimer = null;
        }
        this.horizontalContainer.scroll({ left: this.horizontalScrolledValue + dx });
        this.previousScrollPosition2 = this.previousScrollPosition1;
        this.previousScrollPosition1 = px;
        this.horizontalScrollTimer = setTimeout(this.equalizePosition, 200);
      },
      scrollEnd(e) {
        if (this.horizontalScrollTimer != null) {
          clearTimeout(this.horizontalScrollTimer);
          this.horizontalScrollTimer = null;
        }
        let distance = this.previousScrollPosition2 - this.previousScrollPosition1;
        let from = this.horizontalContainer.scrollLeft;
        let to = from + (distance * 20);
        scrollLeft(this.horizontalContainer, from, to).then(() => {
          this.horizontalScrolling = false;
        });
        window.removeEventListener("pointermove", this.scrollMove);
        window.removeEventListener("pointerup", this.scrollEnd);
      },
      equalizePosition() {
        this.previousScrollPosition2 = this.previousScrollPosition1;
      },
    },
    created() {

    },
    mounted() {
      this.initialize();
    },
    watch: {
      courses: function () {
        this.initialize();
      },
      mode: function () {
        this.$nextTick(() => {
          this.updateDOM();
        });
      },
    },
    emits: ["select"],
    components: {
      "progress-bar": ProgressBarControl,
    },
  });


</script>
